import { DrawerRootProps, Portal, SystemStyleObject } from '@chakra-ui/react';
import {
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerRoot,
} from '@cyberkongz/ui';
import { PropsWithChildren } from 'react';

export function Drawer({
  children,
  styles,
  ...rest
}: DrawerRootProps &
  PropsWithChildren & {
    styles?: {
      content?: SystemStyleObject;
      closeIcon?: SystemStyleObject;
      body?: SystemStyleObject;
      closeTrigger?: SystemStyleObject;
    };
  }) {
  return (
    <Portal>
      <DrawerRoot {...rest}>
        <DrawerBackdrop />
        <DrawerContent {...styles?.content}>
          <DrawerCloseTrigger
            {...styles?.closeTrigger}
            css={{
              '& svg': {
                boxSize: 6,
                ...styles?.closeIcon,
              },
            }}
          />
          <DrawerBody {...styles?.body}>{children}</DrawerBody>
        </DrawerContent>
      </DrawerRoot>
    </Portal>
  );
}
